export default "float cubicIn(float t) {\n  return t * t * t;\n}\n\n"